import React from 'react'
import { useHistory } from 'react-router-dom'
import Logo from '../../assets/images/GrowMore360_Logo.svg'
import { LoginAuthRoute } from '../../router/routes'

const LoginView = () => {
  const history = useHistory()

  const handleLogin = () => {
    history.push(LoginAuthRoute.path)
  }

  return (
    <div className='df fxdrc jcc aic' style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0 }}>
      <div className='bgc-white bd1-s-darkgray w375 pr25 pl25 df fxdrc aic' style={{ padding: '40px 25px', borderRadius: '8px' }}>
        <img src={Logo} alt='Logo' style={{ width: '200px', marginBottom: '40px' }} />
        <button
          onClick={handleLogin}
          style={{
            width: '100%',
            padding: '12px',
            backgroundColor: '#14803C',
            color: '#fff',
            border: 'none',
            borderRadius: '4px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer'
          }}
        >
          Login
        </button>
      </div>
    </div>
  )
}

export default LoginView
